export default "__VITE_ASSET__CNCAkmIe__"